<zwi-widget>
  <mat-list>
    @for (book of oldTestament; track book) {
      <mat-list-item (click)="selectBook(book)" class="zwi-book-menu__item">{{ book.name }}</mat-list-item>
    }
    @for (book of newTestament; track book) {
      <mat-list-item (click)="selectBook(book)" class="zwi-book-menu__item">{{ book.name }}</mat-list-item>
    }
  </mat-list>
</zwi-widget>

